<template>
<div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
            <!-- Modal body -->
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                <div class="subtask_name" style="border-bottom: 1px solid #C8C7C8; padding-bottom: 5px;">{{ subtask_name }}</div>
                <div class="task_count" v-if="heading_name">{{ heading_name }}</div>
                <div class="task_title"> {{ '1. ' + task_description }} </div>
                <div class="row task_card" v-for="(repitition, rindex) in repititions" :key="rindex">
                    <div class="col-6 mb-2" style="padding-left: 0px;">{{ '#'+ repitition.itemCnt + ' - '  }} Rating: {{ repitition.score }} 
                      
                    </div>
                    <div class="col-6 text-right"  style="padding-right: 0px;">{{ repitition.createdAt | formatDate }}</div>
                    <div class="col-12 mb-2"  style="padding-left: 0px;">Mentor: {{ repitition.mentor_name }} </div>
                    <div class="col-5"  style="padding-left: 0px;">Comment: {{ repitition.comment }} </div>
                    <div class="col-7 text-right" style="padding-right: 0px;">Time on Task: {{ repitition.timeOnTask | formatHourMin }} </div>
                </div>
                <div class="col-12" v-if="repititions.length == 0">
                    <div class="remaining-task">No records found</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MMM DD, YYYY')
    }
});

export default {
  props: [
    'isModalVisible',
    'tasklistId',
    'menteeId'
    ],
  data() {
    return {
        task_id: '',
        task_description: '',
        subtask_name: '',
        heading_name: '',
        repititions: '',
        score_options: [],
        score_selected: 0,
        items_options: [],
        items_selected: 0,
        items: '',
        taskTitle: '',
        current_score: '',
        current_score_description: '',
    }
  },
  components: {
  },
  methods: {
    closeModal() {
      this.repititions = [];
      this.$emit('close');
    },
    getTaskItem(taskId, taskDescription, subtaskName, headingName) {
        this.task_id = taskId;
        this.task_description = taskDescription;
        this.subtask_name = subtaskName;
        this.heading_name = headingName;
        //console.log(task);
        axios.get('/mobile/mentee-repetitions-task', {
            params: {
                mentee_id: this.menteeId,
                task_id: this.task_id,
                tasklist_id: this.tasklistId,
                account_id: this.$store.state.user_accountid,
            }
        })
        .then(response =>  {
          this.repititions = response.data.repetition;
        })
        .catch(() => {
          console.log("error comes")
        }); 
    },
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}
.modal-container { 
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 820px;
  padding: 20px 30px;
  background-color: #FFF;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  color: #002F42;
}
.modal-body {
  margin: 0px;
  padding: 10px;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer {
  border-top: none;
}
.modal-body {
  padding: 5px;
}
.subtask_name {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.task_title {
  color: #002F42;
  font-size: 14px;
  font-weight: 400;
  margin: 5px 0 15px 0;
}
.task_count {
  color: #002F42;
  font-size: 14px;
  font-weight: 400;
  margin: 10px 0;
  border-bottom: 0px solid #A6A6A6;
  padding-bottom: 0px;
}
.task_card{
  background-color: #FFF;
  border: 1px solid #FFF;
  border-radius: 0px;
  margin: 10px 0px;
  padding: 10px 0px;
  border-bottom: 1px solid #A6A6A6;
}
.heading_name {
  font-weight: 900;
  margin: 10px;
}
.remaining-task {
  background-color: #FFF;
  border: 1px solid #FFF;
  border-radius: 10px;
  margin: 10px;
  padding: 10px;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manager/report_task_view_repitition.vue